export const stagingOptions = {
	context: { clientName: "staging" },
};

export const wmsOptions = {
	context: { clientName: "wms", fetchPolicy: "network-only" },
};
